import { useTranslation } from 'react-i18next';
import { downloadFile } from '../../File/util';
import { ClickMenuItem } from './ClickMenu';
import { Icon } from './Icon';
import { openNotification } from './Notification';

interface DownloadFileMenuItemOptionProps {
  disabled?: boolean;
  fileName: string;
  downloadURL: string;
  onDownload?: () => Promise<void>;
}

export function DownloadFileMenuItemOption({
  disabled,
  downloadURL,
  fileName,
  onDownload,
}: DownloadFileMenuItemOptionProps) {
  const { t: tFile } = useTranslation('file');
  const download = async () => {
    if (onDownload) {
      await onDownload();
      return;
    }

    const result = await downloadFile(fileName, downloadURL);
    if (!result.ok) {
      openNotification({
        type: 'error',
        description: tFile('error-unable-to-download'),
      });
    }
  };

  return (
    <ClickMenuItem disabled={disabled} hideOnClick onClick={() => void download()}>
      <span className="text-lg font-medium text-white">{tFile('download-file-label')}</span>
      <Icon icon="download" className="text-palette-600" />
    </ClickMenuItem>
  );
}
